import React from 'react';

export default (field) => {
  return (
    <input 
      {...field.input} 
      type={field.type || 'hidden'} 
      placeholder={field.placeholder} />
  );
};